import { useNavigate } from "react-router-dom";
import ReactDataTable from "../../../Components/ReactDataTable";
import SearchIcon from "@mui/icons-material/Search";
import InputAdornment from "@mui/material/InputAdornment";
import {
  getExploreCategory,
  searchExplore,
  updateExploreCategory,
  RemoveCategory,
} from "../../../Redux/Actions/ExploreAction";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState, useMemo } from "react";
import moment from "moment";
import { Box, List, Stack, Button, ButtonGroup } from "@mui/material";
import AddCategoryModal from "./AddCategory";
import { useErrorHandler } from "../../../hooks";
import HelmetReact from "../../../Components/Helmet";
import ActionButton from "../../../Components/ReactDataTable/ActionButton";
import FilterComponent from "../../../Components/ReactDataTable/FilterComponent";
import ResponsiveDialog from "../../../Components/DialogBox";
export const Category = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const {
     loading,
    exploreCategoryList,
    totalCount,
  } = useSelector((state) => state.Explore);
  
  const [filterText, setFilterText] = useState("");
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
  const [open, setOpen] = useState(false);
  const [itemId, setItemId] = useState();
  const [isVisibleModal, setIsVisibleModal] = useState(false);

  let data;
  if (exploreCategoryList?.length) {
    data = exploreCategoryList?.map((e) => e);
  }

  const [navigateUrl, setNavigateUrl] = useState("/explore/");
  const { setMsgConfig } = useErrorHandler();

  const onTableChange = (filter) => {
    const searchPayload = {
      key: filterText || "",
      perPage: filter?.perpage || 10,
      page: filter?.page || 1,
      sortBy: filter?.sortBy || "id",
      sortDirection: filter?.direction || "DESC",
    };
    dispatch(getExploreCategory(searchPayload));
  };
  useEffect(() => {
    onTableChange();
  }, [filterText, open]);

  const subHeaderComponentMemo = useMemo(() => {
    const handleClear = () => {
      if (filterText) {
        setResetPaginationToggle(!resetPaginationToggle);
        setFilterText("");
      }
    };
    return (
      <FilterComponent
        onFilter={(e) => setFilterText(e)}
        onClear={handleClear}
        filterText={filterText}
        placeHolder="Search category by name"
      />
    );
  }, [filterText, resetPaginationToggle]);

  const handleStatusChange = (item, value) => {
    const payload = {
      Id: item?.id,
      is_active: value,
    };
    dispatch(updateExploreCategory(payload));
    setMsgConfig({
      alertOpen: true,
      message: "Program Status Update SuccessFully!!",
      severity: "success",
      autoHideDuration: 2000,
    });
  };
  const RemoveItem = (item) => {
    setIsVisibleModal(true);
    setItemId(item?.id);
  };

  const handleConfirm = () => {
    const payload = {
      Id: itemId,
    };

    dispatch(RemoveCategory(payload));
    setIsVisibleModal(false);
    setMsgConfig({
      alertOpen: true,
      message: "Remove Program SuccessFully!!",
      severity: "success",
      autoHideDuration: 1000,
    });
  };
  const columns = [
    {
      name: "CATEGORY NAME",
      sortField: "name",
      sortable: true,
      selector: (row) => row.name,
      cell: (row) => {
        return (
          <span className="badge bg-light-danger">
            <span>{row.name}</span>
          </span>
        );
      },
    },
    {
      name: "CREATED DATE",
      sortField: "created_at",
      selector: (row) => row.created_at,
      sortable: true,
      cell: (row) => {
        return (
          <span className="badge bg-light-danger">
            <span>
              {row.created_at
                ? moment(row.created_at).format("DD/MM/YYYY")
                : "N/A"}{" "}
            </span>
          </span>
        );
      },
    },
    {
      name: "STATUS",
      sortField: "is_active",
      selector: (row) => row.is_active,
      sortable: true,
      cell: (row) => {
        return (
          <>
            <Box sx={{ display: "flex", gap: "10px" }}>
              <span className="badge bg-light-danger">
                <span className="status">
                  {row.is_active === true ? "Active" : "Inactive"}
                </span>
              </span>
              <span className="status-icon-btn view-detail-btn">
                <ActionButton
                  isUpdateIcon={true}
                  handleStatusChange={handleStatusChange}
                  item={row}
                  isEditMode={true}
                />
              </span>
            </Box>
          </>
        );
      },
    },
    {
      name: "ACTION",
      right: true,
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
      cell: (row) => {
        return (
          <>
            <span className="remove-icon-btn view-detail-btn">
              <ActionButton
                isRemoveIcon={true}
                RemoveItem={RemoveItem}
                item={row}
                isEditMode={true}
              />
            </span>
          </>
        );
      },
    },
  ];

  return (
    <>
      <HelmetReact name="Explore Category" />

      <ResponsiveDialog
        dtype="confirm"
        open={isVisibleModal}
        header="Are you sure you want to delete this Category?"
        onConfirm={() => handleConfirm()}
        onClose={() => setIsVisibleModal(false)}
      ></ResponsiveDialog>
      <Box className="d-details-box">
        <ButtonGroup
          variant="text"
          aria-label="text button group"
        ></ButtonGroup>
        <List component={Stack} direction="row"></List>

        <Box
          sx={{
            textAlign: "right",
          }}
        >
          <Button
            sx={{
              background: "#000",
              marginBottom: "15px",
              borderRadius: "70px",
            }}
            variant="contained"
            onClick={(e) => {
              e.stopPropagation();
              setOpen(true);
            }}
          >
            ADD CATEGORY
          </Button>
        </Box>

        <ReactDataTable
          columns={columns}
          items={data}
          onChange={onTableChange}
          paginationTotalRows={totalCount}
          isLoading={loading}
          navigateUrl={navigateUrl}
          isShowSearch={true}
          paginationResetDefaultPage={resetPaginationToggle}
          subHeader
          subHeaderComponent={subHeaderComponentMemo}
          persistTableHead
        />
      </Box>
      {open && <AddCategoryModal open={open} setOpen={setOpen} />}
    </>
  );
};
